module.exports = __webpack_public_path__ + "img/appdownload-bg2@2x.64abf554.png";